import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import PropTypesHelpers from '@/utils/propTypesHelpers'

import { FieldFeedback } from '../../../generic'
import {
  REQUIRED_ERROR_MESSAGE,
  EMAIL_PATTERN,
  EMAIL_FORMAT_ERROR_MESSAGE
} from '../../constants'

const Input = ({ type, className, placeholder, name, required }) => {
  const { register, formState: { errors } } = useFormContext()
  const isInvalid = errors?.[name]

  const validations = useMemo(() => {
    const validations = {}
    if (required) {
      validations.required = REQUIRED_ERROR_MESSAGE
    }
    if (type === 'email') {
      validations.pattern = {
        value: EMAIL_PATTERN,
        message: EMAIL_FORMAT_ERROR_MESSAGE
      }
    }
    return validations
  }, [required, type])

  return (
    <>
      <input
        id={name}
        type={type}
        className={classnames(className, { 'is-invalid': isInvalid })}
        placeholder={placeholder}
        {...register(name, validations)}
      />
      {type !== 'checkbox' && <FieldFeedback invalid={isInvalid?.message} />}
    </>
  )
}

Input.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypesHelpers.classnames,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired
}

export default Input
